import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  size?: number;
}

export const CzechiaFlag = ({ size = 40, ...props }: Props) => (
  <svg
    aria-hidden="true"
    width={size}
    height={size}
    style={{ borderRadius: "50%" }}
    viewBox="0 0 513 512"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_103_3724)">
      <path d="M0.5 0H512.5V256H0.5V0Z" fill="white" />
      <path d="M0.5 256H512.5V512H0.5V256Z" fill="#D7141A" />
      <path d="M300.5 256L0.5 56V456L300.5 256Z" fill="#11457E" />
    </g>
    <defs>
      <clipPath id="clip0_103_3724">
        <rect
          width="512"
          height="512"
          fill="white"
          transform="translate(0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);
